import './load-service-worker'
import * as webpack from './webpack'
Object.assign(globalThis, webpack)   // needed for reset password (choose_login.js)
import notify from './notify';
(window as any).kb = {notify};
